import { ControlAttributeType } from '@tabeeb/modules/createFormPage/components/ControlAttributes/ControlAttributesDialog'

export const PageMode = {
  create: 'create',
  edit: 'edit',
}

export const ControlAttributes: ControlAttributeType[] = [{ title: 'salesforce_id' }]
